import axios from "axios";
import ExceptionAdapter, { ApiResponseError } from "@/core/exceptions/exception-adapter";

export function normalizeAxiosError(error: unknown): ApiResponseError {
  if (error instanceof ApiResponseError) {
    return error;
  }

  if (axios.isAxiosError(error)) {
    const status = error.response?.status ?? 0;
    const payload =
      error.response?.data ??
      ({
        code: error.code,
        message: error.message,
      } satisfies Record<string, unknown>);

    return new ApiResponseError(
      ExceptionAdapter.getMessage(payload, error.message),
      status,
      payload,
    );
  }

  return new ApiResponseError(ExceptionAdapter.getMessage(error), 500, error);
}
